export default {
  routes: [
    // 热门品牌页
    {
      path: '/brand-home',
      name: 'brandhome',
      meta: {
        desc: '品牌主页',
        pageId: 'B6480',
        isAutoPV: false
      },
      component: () => import(/* webpackChunkName: "brandHome" */ '../views/brand/home.vue')
    },
    {
      path: '/brand-hot',
      name: 'hot',
      meta: {
        title: '热门品牌',
        pageId: 'V8479'
      },
      component: () => import(/* webpackChunkName: "brandHot" */ '../views/brand/hot.vue')
    },
    {
      path: '/brand-mark-intro',
      name: 'brand-mark-intro',
      meta: {
        title: '品牌',
        pageId: 'D9375'
      },
      component: () => import(/* webpackChunkName: "brandMark" */ '../views/brand/mark.vue')
    }
  ]
}
